import React, { useEffect, useRef, useState } from 'react';
import {
	SdfBox, SdfButton,
	SdfIcon, SdfInput,
	SdfSegmentedControl,
	SdfSelectSimple,
	SdfShimmer,
	SdfMultiSelect
} from '@synerg/react-components';
import { get } from "lodash";
import {
	updateIntentDropdownSelection,
	updateSearchResponse,
	useApplicationState
} from "../../../utilities/applicationState";
import {
	handleDomainSelections,
	handleSubCategoriesSelections,
	intentDataList, searchOptions, searchRequest,
	groupSearchResults
} from "../apiDiscoveryWizard";
import Pagination from "./pagination";
import ShoppingCart from "./shoppingCart";
// import RelatedApisModal from "./relatedApisModal";
import AllMultiSelect, { reduceItemList } from '../../common/AllMultiSelect';
import GroupedDomainSubCategoriesView from "./groupedDomainSubCategoriesView";

const includeCheckBoxList = [
	{ label: 'Associated Meta APIs', value: 'meta'},
	{ label: 'CodeList APIs', value: 'codelist'},
	{ label: 'Table list Validation', value: 'table'},
];

export default function ApiSearchPage({ open, filteredApis, setToast, handleError,
	                                      projectIdEncrypted, consumerApplicationID, closeModal,
	                                      subscribedEvents, productCode, scopeLastModified
}) {
	const [selectedSegment, setSelectedSegment] = useState(1);
	const [searchLoading, setSearchLoading] = useState(true);

	const [totalPages, setTotalPages] = useState(1);
	const [totalCount, setTotalCount] = useState(0);
	const [pageNumber, setPageNumber] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(50);

	const [addApis, setAddApis] = useState([]);
	const [missingApis, setMissingApis] = useState([]);
	const [addEvents, setAddEvents] = useState([]);
	const [cartCount, setCartCount] = useState(0);

	//const [relatedApisModalOpen, setRelatedApisModalOpen] = useState(false);

	const [ applicationState, dispatch ] = useApplicationState();
	const { isApiContext } = applicationState.apiDiscovery;

	const selectedIntentData = get(applicationState, 'apiDiscovery.intentDropdownSelection', null);
	const domainData = get(applicationState, 'apiDiscovery.domainDropdownList', []);
	const selectedDomainData =  get(applicationState, 'apiDiscovery.apiDomainDropDownSelection', []);

	const subCategoriesData =  get(applicationState, 'apiDiscovery.subCategoriesDropdownList', []);
	const selectedSubCategoryData = get(applicationState, 'apiDiscovery.subCategoriesDropDownSelection', []);
	const [selectedIncludeCheckBoxValues, setSelectedIncludeCheckBoxValues] = useState(includeCheckBoxList);
	const [searchStr, setSearchStr] = useState(null);
	const [initialCheckBoxStateChanged, setInitialCheckBoxStateChanged] = useState(false);
	const [groupedResults, setGroupedResults] = useState([]);

	const eventSubscriptions = get(applicationState, 'apiDiscovery.searchResponse.eventSubscriptions', []);

	const showEventSubscriptions = eventSubscriptions.length > 0;
	const addedItems = showEventSubscriptions ? addEvents : [ ...addApis, ...missingApis ];

	useEffect(() => {
		if (open && (filteredApis || subscribedEvents)) {
			search();
		} else {
			resetFilters();
			resetShoppingCart();
		}
	}, [open, subscribedEvents]);

	useEffect(() => {
		if ((initialCheckBoxStateChanged && selectedIncludeCheckBoxValues) || searchStr !== null) {
			let searchTimer;
			setSearchLoading(true);

			searchTimer = setTimeout(() => {
				search();
			}, 2000);

			return () => {
				clearTimeout(searchTimer);
			};
		}
	}, [selectedIncludeCheckBoxValues, searchStr]);

	const onSegmentChange = (event) => {
		setSelectedSegment(event.detail);
	};

	const handleRemoveApis = (api) => {
		const newItems = addApis.filter(({ uri, httpMethod }) => uri !== api.uri || httpMethod !== api.httpMethod);
		setAddApis(newItems);
	};

	const handleRemoveEvents = (event) => {
		const newItems = addEvents.filter(({ code, canonicalUri }) => !(code === event.code && canonicalUri === event.canonicalUri));
		setAddEvents(newItems);
	}

	const resetShoppingCart = (api) => {
		setAddApis([]);
		setAddEvents([]);
		setMissingApis([]);
	}

	const resetFilters = () => {
		resetSearchFilter();
		resetIncludeFilter();
		resetTextPathSegment();
	}

	const resetSearchFilter = () => {
		setSearchStr(null);
	}

	const resetIncludeFilter = () => {
		setSelectedIncludeCheckBoxValues(includeCheckBoxList);
	}

	const resetTextPathSegment = () => {
	 setSelectedSegment(1);
	}

	const segments = [{ label: 'Text', value: 0, disabled: selectedIntentData === intentDataList[1] }, { label: 'Path', value: 1, disabled: selectedIntentData === intentDataList[1] }];

	const search = async (pageNumberParam = 1, itemsPerPageParam = 50) => {
		const domainList = reduceItemList(domainData);
		const subCategoryList = reduceItemList(subCategoriesData);

		let searchDomainData = selectedDomainData;
		let searchSubCategoryData = selectedSubCategoryData.map(({ value }) => subCategoryList.find((subCategory) => subCategory.value === value));

		if (selectedDomainData.length === 0) {
			const subCategoryListFromDomain = [];
			domainList.forEach(({ subCategories }) => subCategoryListFromDomain.push(...subCategories));
			handleDomainSelections(domainList, dispatch, domainData, subCategoryListFromDomain);

			searchDomainData = domainList;
			searchSubCategoryData = subCategoryListFromDomain;
		} else if (selectedSubCategoryData.length === 0) {
			handleSubCategoriesSelections(subCategoryList, dispatch);

			searchSubCategoryData = subCategoryList;
		}

		const postData = searchOptions(
			false,
			selectedIntentData,
			searchDomainData,
			searchSubCategoryData,
			filteredApis,
			pageNumberParam,
			itemsPerPageParam,
			selectedIncludeCheckBoxValues,
			searchStr,
			isApiContext,
			subscribedEvents
		);



		try {
			setToast(false)
			setSearchLoading(true);

			const data = await searchRequest(postData, productCode);
			// const data = {
			// 	"totalPages": 20,
			// 	"totalCount": 40,
			// 	"pageNumber": 1,
			// 	"itemsPerPage": 2,
			// 	"nextPage": false,
			// 	"apis": [
			// 		{
			// 			"httpMethod": "get",
			// 			"uri": "/events/money-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta ajsdghkashd jkasgdliashdakshd sjdGFsjdkfgh ",
			// 			"type": "event",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		},
			// 		{
			// 			"httpMethod": "post",
			// 			"uri": "/events/apple-movement/v1/disbursement-check-copy.request/meta",
			// 			"text": "Request Disbursement Check Copy Meta",
			// 			"type": "meta",
			// 			"description": "abc",
			// 			"canonicalUri": "/jshdh"

			// 		}
			// 	]
			// };

			if (data && (data.apis || data.eventSubscriptions)) {
				const addIndexes = (list) => {
					return list.map((itemData, index) => {
						return {
							...itemData,
							index: index
						};
					});
				}

				data.apis ? data.apis = addIndexes(data.apis) : data.eventSubscriptions = addIndexes(data.eventSubscriptions);
				const useApis = data.apis && data.apis.length > 0;
				const useEventSubscriptions = data.eventSubscriptions && data.eventSubscriptions.length > 0;

				const operations = useApis ? data.apis : useEventSubscriptions ? data.eventSubscriptions : [];

				const groupedData = groupSearchResults(operations);
				dispatch(updateSearchResponse(data));
				setGroupedResults(groupedData);

				setTotalPages(data.totalPages);
				setTotalCount(data.totalCount);
				setPageNumber(data.pageNumber);
				setItemsPerPage(data.itemsPerPage);
			}

		} catch (e) {
			const errorMessage = get(e, 'response.data.message', 'Something went wrong while fetching data for selected options. Please try again.');
			handleError(errorMessage);
		} finally {
			setSearchLoading(false);
		}
	};

	const handlePaginationChange = (totalPagesParam, totalCountParam, pageNumberParam, itemsPerPageParam) => {
		setTotalPages(totalPagesParam);
		setTotalCount(totalCountParam);
		setPageNumber(pageNumberParam);
		setItemsPerPage(itemsPerPageParam);

		search(pageNumberParam, itemsPerPageParam);
	}

	const addLinkRef = useRef(null);

	// scroll to view useEffect
	useEffect(() => {
		if (addApis && addLinkRef.current && (addApis.length > cartCount)) {
			// add operation
			addLinkRef.current.scrollIntoView({ behavior: 'smooth', inline: 'end'});
		}
		setCartCount(addApis.length);
	}, [addApis])

	const handleAddToCart = (item, isApis) => {
		if (!showEventSubscriptions || isApis) {
			setAddApis([...addApis, item]);
		} else {
			setAddEvents([...addEvents, item]);
		}
		if (addLinkRef.current) {
			addLinkRef.current.scrollIntoView({ behavior: 'smooth', inline: 'end'});
		}
	}

	// const openRelatedApisModal = () => setRelatedApisModalOpen(true);
	//const closeRelatedApisModal = () => setRelatedApisModalOpen(false);


	return (<>
		<div className="flex flex-row gap-6 mx-8 h-full">
		<div className="discovery-width h-full flex flex-col">
			<div className="flex-row pb-4">
				<SdfBox layout="default" variant="filled" fill="shaded" shape="rounded" className='flex gap-6 justify-center items-end'>
				<SdfSelectSimple
				className="w-1/4 wizard-list"
				portalEnabled={'true'}
				placeholder="Select API Intent"
				label={"API Intent"}
				value={selectedIntentData}
				items={intentDataList}
				input_width={"md"}
				onSdfChange={(event) => {
					dispatch(updateIntentDropdownSelection(event.detail));
				}}
				></SdfSelectSimple>
				<AllMultiSelect
					portalEnabled={'true'}
					disabled={false}
					className="w-1/4"
					placeholder="Select Domain"
					label={"API Domain"}
					value={selectedDomainData}
					items={domainData}
					input_width={"md"}
					onSdfChange={(event) => handleDomainSelections(event.detail, dispatch, domainData, selectedSubCategoryData)}
				/>
				<AllMultiSelect
					portalEnabled={'true'}
					className="w-2/6"
					placeholder="Select Sub-Categories"
					label={"Sub-Categories"}
					disabled={selectedDomainData.length < 1}
					value={selectedSubCategoryData}
					items={subCategoriesData}
					input_width={"md"}
					onSdfChange={(event) => handleSubCategoriesSelections(event.detail, dispatch)}
				/>
					<SdfButton className="self-end" emphasis='primary' onClick={() => {
						search();
					}}>
						Apply
					</SdfButton>
					</SdfBox>
			</div>
			<div className="flex items-start gap-6 mt-1 mb-4 items-center">
				<div className="text-heading-06 font-black self-end">Results ({totalCount})</div>
				<SdfMultiSelect
					portalEnabled={'true'}
					className="w-56"
					label={"Include"}
					value={selectedIntentData === intentDataList[1] ? [] : selectedIncludeCheckBoxValues}
					items={includeCheckBoxList}
					input_width={"md"}
					disabled={selectedIntentData === intentDataList[1]}
					onSdfChange={(event) => {
						setInitialCheckBoxStateChanged(true);
						setSelectedIncludeCheckBoxValues(event.detail);
					}}
				/>
				<SdfSegmentedControl
				className={"self-end"}
				items={segments}
				onSdfChange={(event) => onSegmentChange(event)}
				selectedIndex={selectedSegment}
				default={selectedSegment}
				/>
				<SdfInput
				className={"w-2/5"}
				label={"Search"}
				placeholder={"Search"}
				onSdfInput={($event) => {
					setSearchStr($event.detail);
				}}
				value={searchStr}
				>
					<SdfIcon slot={"after"} icon={"action-search"}></SdfIcon>
				</SdfInput>
			</div>
			<div className="flex-grow overflow-y-auto mb-4">
			{searchLoading ?
			(<SdfShimmer rows={15} />) :
			<GroupedDomainSubCategoriesView
				selectedSegment={selectedSegment}
				handleError={handleError}
				handleAddToCart={handleAddToCart}
				showEventSubscriptions={showEventSubscriptions}
				productCode={productCode}
				{...{ addedItems, groupedResults }}
			/>}
			</div>
			<Pagination
			{...{ totalPages, totalCount, pageNumber, itemsPerPage, handlePaginationChange}}
			/>
		</div>
			<div className="flex flex-col w-2/6 h-full">
				<ShoppingCart
					projectIdEncrypted={projectIdEncrypted}
					consumerApplicationID={consumerApplicationID}
					closeModal={closeModal}
					resetShoppingCart={resetShoppingCart}
					setToast={setToast}
					handleError={handleError}
					addLinkRef={addLinkRef}
					scopeLastModified={scopeLastModified}
					search={search}
					{...{
						addApis, addEvents, handleRemoveApis, handleRemoveEvents, filteredApis, subscribedEvents, productCode,
						missingApis, setMissingApis
					}}
				/>
				{/* <SdfBox
					className="gap-y-2 bg-action-default-200 recommended-apis-box"
					layout="vertical"
					variant="filled"
					shape="squared"
				>
					<div className="flex">
						<div className="text-heading-05 font-bold flex-grow self-center">Related APIs</div>
						<SdfButton emphasis={"secondary"} onClick={openRelatedApisModal}>
							View Related APIs
						</SdfButton>
					</div>
					{
						addApis?.length > 0 ?
						<>
							<div>Users like you who made similar choices also added these APIs</div>
						</> :
						<div>Add an API to see other APIs chosen by users like you.</div>
					}
				</SdfBox> */}
			</div>
		</div>
		{/*<RelatedApisModal*/}
		{/*	isOpen={relatedApisModalOpen} onClose={closeRelatedApisModal} projectId={projectIdEncrypted}*/}
		{/*	{...{*/}
		{/*		segments, handleError, handleAddToCart, addedItems,*/}
		{/*		selectedIntentData, selectedDomainData, selectedSubCategoryData, filteredApis*/}
		{/*	}}*/}
		{/*/>*/}
	</>
	)
}
